module.exports = __webpack_public_path__ + "static/img/donation.dd6eaad.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/zhuzhou/donation.png
// module id = ed7g
// module chunks = 1